import {
  IApiContentResponseModel,
  BookIntroContentResponseModel,
  BookIntroContentResponseModelContentType,
  BookFlowEatAndDrinkContentResponseModel,
  BookFlowEatAndDrinkContentResponseModelContentType,
  BookFlowSunbedContentResponseModel,
  BookFlowSunbedContentResponseModelContentType,
  BookFlowParkingContentResponseModelContentType,
  BookFlowParkingContentResponseModel,
  BookFlowStayContentResponseModel,
  BookFlowStayContentResponseModelContentType,
  BookFlowExperiencesContentResponseModelContentType,
  BookFlowExperiencesContentResponseModel,
  BookFlowRangeRoverContentResponseModelContentType,
  BookFlowRangeRoverContentResponseModel,
  BookFlowEventContentResponseModelContentType,
  BookFlowEventContentResponseModel,
} from '@/services/platform/api/model';
import { AppContext } from '@/lib/core/types';
import { BookIntroEngine } from './intro';
import { BookFlowEatAndDrink } from './flows/eat-and-drink';
import { BookFlowSunbed } from './flows/sunbed';
import { BookFlowParking } from './flows/parking';
import { BookFlowStay } from './flows/stay';
import { BookFlowExperience } from './flows/experience';
import { BookFlowRangeRover } from './flows/range-rover';
import { BookFlowEvent } from './flows/event';

interface BookingEngineProps {
  content: IApiContentResponseModel;
  context?: AppContext;
}

const contentTypeMap = {
  [BookIntroContentResponseModelContentType.bookIntro]: (
    content: IApiContentResponseModel,
    context?: AppContext
  ) => <BookIntroEngine content={content as BookIntroContentResponseModel} context={context} />,

  [BookFlowEatAndDrinkContentResponseModelContentType.bookFlowEatAndDrink]: (
    content: IApiContentResponseModel,
    context?: AppContext
  ) => <BookFlowEatAndDrink content={content as BookFlowEatAndDrinkContentResponseModel} context={context} />,

  [BookFlowSunbedContentResponseModelContentType.bookFlowSunbed]: (
    content: IApiContentResponseModel,
    context?: AppContext
  ) => <BookFlowSunbed content={content as BookFlowSunbedContentResponseModel} context={context} />,

  [BookFlowParkingContentResponseModelContentType.bookFlowParking]: (
    content: IApiContentResponseModel,
    context?: AppContext
  ) => <BookFlowParking content={content as BookFlowParkingContentResponseModel} context={context} />,

  [BookFlowStayContentResponseModelContentType.bookFlowStay]: (
    content: IApiContentResponseModel,
    context?: AppContext
  ) => <BookFlowStay content={content as BookFlowStayContentResponseModel} context={context} />,

  [BookFlowExperiencesContentResponseModelContentType.bookFlowExperiences]: (
    content: IApiContentResponseModel,
    context?: AppContext
  ) => <BookFlowExperience content={content as BookFlowExperiencesContentResponseModel} context={context} />,

  [BookFlowRangeRoverContentResponseModelContentType.bookFlowRangeRover]: (
    content: IApiContentResponseModel,
    context?: AppContext
  ) => <BookFlowRangeRover content={content as BookFlowRangeRoverContentResponseModel} context={context} />,

  [BookFlowEventContentResponseModelContentType.bookFlowEvent]: (
    content: IApiContentResponseModel,
    context?: AppContext
  ) => <BookFlowEvent content={content as BookFlowEventContentResponseModel} context={context} />,
} as const;

export function BookingEngine({ content, context }: BookingEngineProps) {
  const render = contentTypeMap[content.contentType as keyof typeof contentTypeMap];
  return render ? render(content, context) : null;
}
